export default __webpack_public_path__ + "static/media/mascot.c90b742b.svg";